import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store/store";
import TaxpayerCategoryService from '../services/TaxpayerCategoryService';
import { loadingTaxpayerCategoryDropdown } from '../store/slices/taxpayerCategories/taxpayerCategorySlice';

export const useTaxpayerCategory = () => {
  const dispatch: AppDispatch = useDispatch();

  const { taxpayerCategoryDropdown } = useSelector(
    (state: RootState) => state.taxpayerCategory
  );

  const fetchTaxpayerCategoryDropdown = async () => {
    try {
      const response = await TaxpayerCategoryService.fetchDropdown();
      dispatch(loadingTaxpayerCategoryDropdown(response));
    } catch (error) {
      console.error("Error al cargar taxpayer categories:", error);
    }
  };

  return {
    taxpayerCategoryDropdown,
    fetchTaxpayerCategoryDropdown,
  };
};
